import { request } from "utils/axios";

export const getCategories = async () => {
    try {
        const res = await request.get('get-new-categories');
        const payload = res?.data;
        const data = Array.isArray(payload?.data) ? payload.data : [];

        // Normalize "new" categories shape to what the app expects elsewhere:
        // - `visible` used in many UI filters
        // - `uuid` used in routes like `/category/:name/:uuid`
        // - `image_url` used by Navbar category list
        const normalized = data.map((c) => ({
            ...c,
            uuid: c?.uuid ?? String(c?.id ?? ''),
            visible: c?.visible ?? 1,
            image_url: c?.image_url ?? c?.mobile_image_url ?? c?.hd_mobile_image_url ?? null,
        }));

        return { ...payload, data: normalized };
    } catch (error) {
        console.log(error?.response?.data?.message, 'something went wrong');
        throw error;
    }
};

export const products = async () => {
    try {
        const res = await request.get('get-new-products');
        const payload = res?.data;
        const data = Array.isArray(payload?.data) ? payload.data : [];

        // Normalize "new" products shape to what the UI expects:
        // - many components expect `medias` to be an array of objects with `.filename`
        // - some flows expect `is_out` to be boolean
        const normalized = data.map((p) => ({
            ...p,
            is_out: typeof p?.is_out === "number" ? p.is_out === 1 : Boolean(p?.is_out),
            medias: Array.isArray(p?.medias)
                ? p.medias.map((m) => (typeof m === "string" ? { filename: m, platform: "web", type: "normal" } : m))
                : [],
        }));

        return { ...payload, data: normalized };
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings went wrong');
        throw error;
    }
};

export const productsByCategory = async (categoryId) => {
    try {
        const res = await request.get(`get-new-products-by-category/${categoryId}`);
        const payload = res?.data;
        const data = Array.isArray(payload?.data) ? payload.data : [];

        const normalized = data.map((p) => ({
            ...p,
            is_out: typeof p?.is_out === "number" ? p.is_out === 1 : Boolean(p?.is_out),
            medias: Array.isArray(p?.medias)
                ? p.medias.map((m) => (typeof m === "string" ? { filename: m, platform: "web", type: "normal" } : m))
                : [],
        }));

        return { ...payload, data: normalized };
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings went wrong');
        throw error;
    }
};

export const getCoupon = async (value) => {
    try {
        const res = await request.get(`coupons/web/${value}`);
        return res?.data;
    } catch (err) {
        throw err;
    }
}

export const product = async (uuid) => {
    try {
        const res = await request.get(`products/${uuid}`);
        return res?.data;
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings');
        throw error;
    }
};

export const getHomes = async () => {
    try {
        const res = await request.get(`homes`);
        console.log(res)
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong at address');
        return error;
    }
};

export const createAddress = async (value) => {
    try {
        const res = await request.post(`users/addresses`, value);
        console.log(res)
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong creating address');
        return error;
    }
}

export const getAddress = async () => {
    try {
        const res = await request.get(`users/addresses`);

        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong creating address');
        return error;
    }
}

export const deleteAddress = async (id) => {
    try {
        const res = await request.delete(`users/addresses/${id}`);
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong creating address');
        return error;
    }
};


export const dispenserRepair = async (value) => {
    try {
        const res = await request.post(`dispensers`, value);
        return res?.data
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong creating address');
        return error;
    }
};

export const vip = async (value) => {
    try {
        const res = await request.post(`users/vip`, value);
        return res?.data;
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong creating address');
        return error;
    }
};

export const getVip = async () => {
    try {
        const res = await request.get(`users/vip`);
        return res?.data;
    } catch (error) {
        console.log(error?.response?.data?.message, 'somethings wrong creating address');
        return error;
    }
};


export const initPayment = async (value) => {
    try {
        const res = await request.post(`payments/init`, value);
        return res?.data;
    } catch (err) {
        throw err;
    }
}


export const verifyPayment = async (value) => {
    try {
        const res = await request.post(`payments/verify`, value);
        return res?.data;
    } catch (err) {
        throw err;
    }
}



